import { GraphUtils } from '@helpers/graph.helper';
import { Router } from '@angular/router';
import { Sensor } from '@models/sensor/sensor';
import { UtilsHelper } from '@helpers/utils.helper';

export class WaterCounterPulseAttribute extends Sensor {
  public waterGraph: any;
  public waterHourGraph: any;
  public waterMonthGraph: any;
  public iconsToDisplay: { icon: string, type: number }[] = [];

  private waterSensor: any[][] = [];
  private waterHourSensor: any[][] = [];
  private waterMonthSensor: any[][] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.waterGraph = null;
  }

  private ensureArraySize(arr: any[][], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public hasWaterSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.waterSensor.length &&
      this.waterSensor[index].length > 0
    );
  }

  public getWaterSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.waterSensor.length) {
      const sensorData = this.waterSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public hasHourWaterSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.waterHourSensor.length &&
      this.waterHourSensor[index].length > 0
    );
  }

  public getHourWaterSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.waterHourSensor.length) {
      const sensorData = this.waterHourSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public hasMonthWaterSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.waterMonthSensor.length &&
      this.waterMonthSensor[index].length > 0
    );
  }

  public getMonthWaterSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.waterMonthSensor.length) {
      const sensorData = this.waterMonthSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const pos = element.position ?? 0;
      const liters = element.water ?? 0;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.waterSensor, pos);
      this.ensureArraySize(this.waterHourSensor, pos);
      this.ensureArraySize(this.waterMonthSensor, pos);

      const date = new Date(element.date);
      const day = GraphUtils.getDay(date);
      const hour = GraphUtils.getHour(date);
      const month = GraphUtils.getMoth(date);

      // Día
      const currentDay = this.waterSensor[pos].find(e => e[0] === day);
      if (currentDay) {
        currentDay[1] += liters;
      } else {
        this.waterSensor[pos].push([day, liters]);
      }

      // Hora
      const currentHour = this.waterHourSensor[pos].find(e => e[0] === hour);
      if (currentHour) {
        currentHour[1] += liters;
      } else {
        this.waterHourSensor[pos].push([hour, liters]);
      }

      // Mes
      const currentMonth = this.waterMonthSensor[pos].find(e => e[0] === month);
      if (currentMonth) {
        currentMonth[1] += liters;
      } else {
        this.waterMonthSensor[pos].push([month, liters]);
      }
    }
    this.iconsToDisplay = Array.from(iconMap.values());

  }

  public setCharts(): void {
    const filteredWaterSensor = this.waterSensor.filter(series => series.length > 0);
    const positionNodeWaterSensor = this.waterSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.waterGraph = this.getConfigChar(
      'pulse',
      this.getChartSeriesNewNode('Sensor', filteredWaterSensor, positionNodeWaterSensor),
      this.getRanges('43_value_daily'),
      this.getLimits('43_value_daily'),
      'column'
    );

    const filteredWaterHour = this.waterHourSensor.filter(series => series.length > 0);
    const positionNodeWaterHour = this.waterHourSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.waterHourGraph = this.getConfigChar(
      'pulseHour',
      this.getChartSeriesNewNode('Sensor', filteredWaterHour, positionNodeWaterHour),
      this.getRanges('43_value_hour'),
      this.getLimits('43_value_hour'),
      'column'
    );

    const filteredWaterMonth = this.waterMonthSensor.filter(series => series.length > 0);
    const positionNodeWaterMonth = this.waterMonthSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.waterMonthGraph = this.getConfigChar(
      'pulseMonth',
      this.getChartSeriesNewNode('Sensor', filteredWaterMonth, positionNodeWaterMonth),
      this.getRanges('43_value_monthly'),
      this.getLimits('43_value_monthly'),
      'column'
    );
  }

  public static getVariables(): any[] {
    return [
      { title: 'Consumo de agua por hora', value: '43_value_hour' },
      { title: 'Consumo de agua diario', value: '43_value_daily' },
      { title: 'Consumo de agua mensual', value: '43_value_monthly' }
    ];
  }
}
